/* SEASON - Judge.me dedupe

   Hand-built product templates carry their own #judgeme_product_reviews
   container, while sections/product.liquid renders one for every template.
   Two containers share an id, and Judge.me's script only enhances one of
   them - the other never gets its Reviews / Questions tabs.

   So the rule is: keep the copy the script actually enhanced (the one whose
   action row has content, i.e. the tabs), then the one with review markup,
   then whatever came first. Runs repeatedly for a few seconds because the
   enhancement lands after first paint.
*/
(function () {
  function score(node) {
    var actions = node.querySelector('.jdgm-row-actions');
    if (actions && actions.children.length) return 3;   // enhanced: has tabs
    if (node.querySelector('.jdgm-rev')) return 2;      // has reviews
    if (node.querySelector('.jdgm-rev-widg')) return 1; // has widget markup
    return 0;
  }

  function dedupe() {
    var nodes = Array.prototype.slice.call(
      document.querySelectorAll('#judgeme_product_reviews, .jdgm-review-widget')
    ).filter(function (n) {
      return !n.hasAttribute('data-season-dropped');
    });
    if (nodes.length < 2) return;

    var keep = nodes[0];
    var best = score(keep);
    nodes.forEach(function (n) {
      var s = score(n);
      if (s > best) { best = s; keep = n; }
    });

    // Only drop the others once the keeper is actually enhanced, so we never
    // throw away the copy that was about to receive the tabs.
    if (best < 3) return;

    nodes.forEach(function (n) {
      if (n === keep || keep.contains(n) || n.contains(keep)) return;
      n.setAttribute('data-season-dropped', '');
      n.parentNode && n.parentNode.removeChild(n);
    });

    keep.id = 'judgeme_product_reviews';
  }

  dedupe();
  document.addEventListener('DOMContentLoaded', dedupe);

  var passes = 0;
  var settle = setInterval(function () {
    dedupe();
    if (++passes > 30) clearInterval(settle);
  }, 300);
})();
